/* eslint-disable import/no-unresolved */
import { VALIDATIONS, buildValidation } from '~utils/inputValidations';

import { FIELDS } from './constants';

export const validationSchema = buildValidation({
  [FIELDS.APARTMENT]: VALIDATIONS.apartmentDetails,
  [FIELDS.NOTE]: VALIDATIONS.placesAddress
});
